/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_NewInputs */

const th_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่มผู้เล่นใหม่`)
};

const en_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New player`)
};

const ja_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい選手`)
};

const zh_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新球员`)
};

const es_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo jugador`)
};

const pt_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo jogador`)
};

const id_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain baru`)
};

const fr_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau joueur`)
};

const tl_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagong manlalaro`)
};

const vi_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cầu thủ mới`)
};

const ko_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 선수`)
};

const de_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Spieler`)
};

const ru_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый игрок`)
};

const tr_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni oyuncu`)
};

const it_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo giocatore`)
};

const pl_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowy zawodnik`)
};

const uk_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новий гравець`)
};

const hi_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया खिलाड़ी`)
};

const ar_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لاعب جديد`)
};

const ms_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain baharu`)
};

const bn_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নতুন খেলোয়াড়`)
};

const zh_tw2_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新球員`)
};

const zh_hk2_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新球員`)
};

const ur_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نیا کھلاڑی`)
};

const fa_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازیکن تازه`)
};

const sw_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mchezaji mpya`)
};

const nl_player_new = /** @type {(inputs: Player_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe speler`)
};

/**
* | output |
* | --- |
* | "New player" |
*
* @param {Player_NewInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_new = /** @type {((inputs?: Player_NewInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_NewInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_new(inputs)
	if (locale === "ja") return ja_player_new(inputs)
	if (locale === "zh") return zh_player_new(inputs)
	if (locale === "es") return es_player_new(inputs)
	if (locale === "pt") return pt_player_new(inputs)
	if (locale === "id") return id_player_new(inputs)
	if (locale === "fr") return fr_player_new(inputs)
	if (locale === "tl") return tl_player_new(inputs)
	if (locale === "vi") return vi_player_new(inputs)
	if (locale === "ko") return ko_player_new(inputs)
	if (locale === "de") return de_player_new(inputs)
	if (locale === "ru") return ru_player_new(inputs)
	if (locale === "tr") return tr_player_new(inputs)
	if (locale === "it") return it_player_new(inputs)
	if (locale === "pl") return pl_player_new(inputs)
	if (locale === "uk") return uk_player_new(inputs)
	if (locale === "hi") return hi_player_new(inputs)
	if (locale === "ar") return ar_player_new(inputs)
	if (locale === "ms") return ms_player_new(inputs)
	if (locale === "bn") return bn_player_new(inputs)
	if (locale === "zh-TW") return zh_tw2_player_new(inputs)
	if (locale === "zh-HK") return zh_hk2_player_new(inputs)
	if (locale === "ur") return ur_player_new(inputs)
	if (locale === "fa") return fa_player_new(inputs)
	if (locale === "sw") return sw_player_new(inputs)
	if (locale === "nl") return nl_player_new(inputs)
	return en_player_new(inputs)
});